<script>
  import SmallTitle from '../common/SmallTitle.svelte';
  import Official from './Official.svelte';

  export let officials;
  export let lang = undefined;

  const i18n = {
    officials: {
      cs: 'Oficiálové',
      en: 'Officials',
    },
    delegates: {
      cs: 'Delegáti',
      en: 'Delegates',
    },
    commissioners: {
      cs: 'Komisaři',
      en: 'Commissioners',
    },
    umpireSupervisors: {
      cs: 'Vedoucí rozhodčích',
      en: 'Umpire supervisors',
    },
    umpires: {
      cs: 'Rozhodčí',
      en: 'Umpires',
    },
    scorerSupervisors: {
      cs: 'Vedoucí zapisovatelů',
      en: 'Scorer supervisors',
    },
    scorers: {
      cs: 'Zapisovatelé',
      en: 'Scorers',
    },
  };

  const delegates = officials.filter(official => official.position === 'delegate');
  const commissioners = officials.filter(official => official.position === 'commissioner');

  const umpireSupervisors = officials.filter(official => official.position === 'umpire-supervisor');
  const umpires = officials.filter(official => official.position === 'umpire');

  const scorerSupervisors = officials.filter(official => official.position === 'scorer-supervisor');
  const scorers = officials.filter(official => official.position === 'scorer');
</script>

{#if officials.length > 0}
  <div class='officials-box'>
    <SmallTitle value={i18n.officials[lang]}/>

    {#if delegates.length > 0}
      <div class='officials-box-delegates'>
        <div class='officials-box-delegates-small-title'>
          <SmallTitle value={i18n.delegates[lang]} small={true}/>
        </div>

        <div class='officials-box-delegates-officials'>
          <Official value={delegates} bind:lang/>
        </div>
      </div>
    {/if}

    {#if commissioners.length > 0}
      <div class='officials-box-commissioners'>
        <div class='officials-box-commissioners-small-title'>
          <SmallTitle value={i18n.commissioners[lang]} small={true}/>
        </div>

        <div class='officials-box-commissioners-officials'>
          {#each commissioners as commisioner}
            <Official value={commisioner} bind:lang/>
          {/each}
        </div>
      </div>
    {/if}

    {#if umpireSupervisors.length > 0}
      <div class='officials-box-umpire-supervisors'>
        <div class='officials-box-umpire-supervisors-small-title'>
          <SmallTitle value={i18n.umpireSupervisors[lang]} small={true}/>
        </div>

        <div class='officials-box-umpire-supervisors-officials'>
          {#each umpireSupervisors as umpireSupervisor}
            <Official value={umpireSupervisor} bind:lang/>
          {/each}
        </div>
      </div>
    {/if}

    {#if umpires.length > 0}
      <div class='officials-box-umpires'>
        <div class='officials-box-umpires-small-title'>
          <SmallTitle value={i18n.umpires[lang]} small={true}/>
        </div>

        <div class='officials-box-umpires-officials'>
          {#each umpires as umpire}
            <Official value={umpire} bind:lang/>
          {/each}
        </div>
      </div>
    {/if}

    {#if scorerSupervisors.length > 0}
      <div class='officials-box-scorer-supervisors'>
        <div class='officials-box-scorer-supervisors-small-title'>
          <SmallTitle value={i18n.scorerSupervisors[lang]} small={true}/>
        </div>

        <div class='officials-box-scorer-supervisors-officials'>
          {#each scorerSupervisors as scorerSupervisor}
            <Official value={scorerSupervisor} bind:lang/>
          {/each}
        </div>
      </div>
    {/if}

    {#if scorers.length > 0}
      <div class='officials-box-scorers'>
        <div class='officials-box-scorers-small-title'>
          <SmallTitle value={i18n.scorers[lang]} small={true}/>
        </div>

        <div class='officials-box-scorers-officials'>
          {#each scorers as scorer}
            <Official value={scorer} bind:lang/>
          {/each}
        </div>
      </div>
    {/if}
  </div>
{/if}

<style>
  .officials-box {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .officials-box-delegates, .officials-box-commissioners,
  .officials-box-umpire-supervisors, .officials-box-umpires,
  .officials-box-scorer-supervisors, .officials-box-scorers {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .officials-box-delegates-officials, .officials-box-commissioners-officials,
  .officials-box-umpire-supervisors-officials, .officials-box-umpires-officials,
  .officials-box-scorer-supervisors-officials, .officials-box-scorers-officials {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
</style>
